var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47152",
    "data-name": "Group 47152",
    transform: "translate(-10.029 -3.001)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5811",
    "data-name": "Line 5811",
    x1: 12.8,
    y2: 5.148,
    transform: "translate(11.529 4.353)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5812",
    "data-name": "Line 5812",
    x2: 1,
    y2: 6,
    transform: "translate(24.529 4.501)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5813",
    "data-name": "Line 5813",
    x1: 5.881,
    y2: 2.198,
    transform: "translate(19.529 10.303)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16367",
    "data-name": "Path 16367",
    d: "M0,0,7.807,4",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 11.346, 9.334)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_16564",
    "data-name": "Path 16564",
    transform: "translate(10.029 8.001)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 2.75 C 0.8107500076293945 2.75 0.25 2.189249992370605 0.25 1.5 C 0.25 0.8107500076293945 0.8107500076293945 0.25 1.5 0.25 C 2.189249992370605 0.25 2.75 0.8107500076293945 2.75 1.5 C 2.75 2.189249992370605 2.189249992370605 2.75 1.5 2.75 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.5 0.5 C 0.9486000537872314 0.5 0.5 0.9486000537872314 0.5 1.5 C 0.5 2.051399946212769 0.9486000537872314 2.5 1.5 2.5 C 2.051399946212769 2.5 2.5 2.051399946212769 2.5 1.5 C 2.5 0.9486000537872314 2.051399946212769 0.5 1.5 0.5 M 1.5 0 C 2.328429937362671 0 3 0.6715700626373291 3 1.5 C 3 2.328429937362671 2.328429937362671 3 1.5 3 C 0.6715700626373291 3 0 2.328429937362671 0 1.5 C 0 0.6715700626373291 0.6715700626373291 0 1.5 0 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3466",
    "data-name": "Ellipse 3466",
    transform: "translate(23.029 3.001)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3467",
    "data-name": "Ellipse 3467",
    transform: "translate(24.029 9.001)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3468",
    "data-name": "Ellipse 3468",
    transform: "translate(18.029 11.001)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.25,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceTooltipIcon);
export default __webpack_public_path__ + "static/media/source-tooltip-icon.9a0de477b368446f3da09997139e3c7b.svg";
export { ForwardRef as ReactComponent };